import { http } from '../config';
import base from './base';

export const homePage = {
  homeInfo(data) {
    //获取首页信息
    return http({
      url: `${base.users}/tea/homePage`,
      method: 'post',
      data
    });
  },
  getServerTime() {
    //获取服务器时间
    return http({
      url: `${base.users}/teacherProxy/systemTime`,
      method: 'get'
    });
  },
  logout(isApp) {
    //退出登录
    return http({
      url: `${base.users}/user/logout/${isApp}`,
      method: 'post'
    });
  },
  login(data) {
    //登录
    return http({
      url: `${base.users}/user/login`,
      method: 'post',
      data
    });
  },
  checkUserPhone(data) {
    //验证用户手机号是否存在
    return http({
      url: `${base.users}/tea/checkPhone`,
      method: 'get',
      params: data
    });
  },
  jumpAgreement() {
    return http({
      url: `${base.users}/tea/nonCompeteAgreement`,
      method: 'get'
    });
  },
  queryHelpDocuments(data) {
    return http({
      url: `${base.config}/aboutUs/queryHelpDocuments`,
      method: 'post',
      data
    });
  },
  queryHelpDocumentsInfo(id) {
    return http({
      url: `${base.config}/aboutUs/queryHelpDocumentsInfo/${id}`,
      method: 'get'
    });
  },
  teaFreeLoginYiKe(data) {
    return http({
      url: `${base.config}/specialNeed/teaFreeLoginYiKe`,
      method: 'post',
      data
    });
  },
  queryTeaDdRobotGroupMsgConfig() {
    return http({
      url: `${base.users}/tea/queryTeaDdRobotGroupMsgConfig`,
      method: 'get'
    });
  },
  teaDdRobotGroupMsgConfig(data) {
    return http({
      url: `${base.users}/tea/teaDdRobotGroupMsgConfig`,
      method: 'post',
      data
    });
  },
  teaTestDdRobotGroupMsgConfig(data) {
    return http({
      url: `${base.users}/tea/teaTestDdRobotGroupMsgConfig`,
      method: 'post',
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/homePage.js